<div [ngStyle]="avatarStyle">
  <img *ngIf="src; else initialsTemplate" [src]="src" alt="avatar" />
  <ng-template #initialsTemplate>{{ initials }}</ng-template>
</div>
